var app = app || {};
window.app = app; // expose for inline javascripts (kendo server wrappers)
app.cw = app.cw || {};
app.cw.common = app.cw.common || {};

if (!String.prototype.includes) {
    String.prototype.includes = function () {
        'use strict';
        return String.prototype.indexOf.apply(this, arguments) !== -1;
    };
}

$.ajaxSetup({
    cache: false,
    traditional: true
});
$.ajaxPrefilter(function (options, originalOptions) {
    const isPostMethod = options.type.toLowerCase() === 'post' ? true : false;
    const isJsonContent = options.contentType.toLowerCase().indexOf('application/json') !== -1 ? true : false;
    if (isPostMethod && !isJsonContent) {
        if (!originalOptions.data || (typeof originalOptions.data !== 'string' && typeof originalOptions.data !== 'object')) {
            originalOptions.data = {};
        }
        let hasToken = false;
        // deparam method converts foo=bar&hello=hello+world to {'foo':'bar','hello':'hello world'}
        const postedParams = typeof originalOptions.data === 'string' ? $.deparam(originalOptions.data) : originalOptions.data;
        $.each(postedParams, function (k, v) {
            if ('__RequestVerificationToken' === k) {
                hasToken = true;
                return false; // break
            }
        });
        if (!hasToken) {
            var $token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]');
            if ($token.length) {
                if (typeof originalOptions.data === 'string') {
                    options.data = originalOptions.data + "&" + '__RequestVerificationToken=' + $token.val();
                }
                else {
                    options.data = $.param($.extend(originalOptions.data, { __RequestVerificationToken: $token.val() }), true);
                }
            }
        }
    }
});

$(function () {
    // ----------------------------- Kendo Global Settings ----------------------------- //
    kendo.culture().numberFormat.currency.pattern[0] = "-$n"; // Override current culture for negative numbers ($n) -> -$n

    // ----------------------------- Initialize Bootstrap Tooltip ----------------------------- //
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });

    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
    const popoverList = [...popoverTriggerList].map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, { html: true, trigger: 'hover click' });
    });

    $(document.body).on('click', '.cw_ajax_print_btn', function () {
        window.print();
    });

    $(document.body).on('click', '.cw_ajax_contact_view_map_link', function (e) {
        e.preventDefault();

        const url = $(e.target).data('url');
        window.open(url, 'mapswindow');
    });

    $(document.body).on('click', '.cw_ajax_account_holding_btn', function (e) {
        e.preventDefault();
        const accountId = $(e.currentTarget).data('account-id');
        const accountNumber = $(e.currentTarget).data('account-number');
        const url = $(e.currentTarget).data('url');
        app.cw.common.PopupModal.show('Holdings for ' + accountNumber,
            url,
            {
                AccountId: accountId,
                DateFilter: $('#PershingAccountDateFilter').data('kendoDropDownList')?.value(),
                ...app.cw.common.Kendo.forgeryToken()
            });
    });

    $(document.body).on('click', '.cw_ajax_account_retirement_data_btn', function (e) {
        e.preventDefault();
        const accountId = $(e.currentTarget).data('account-id');
        const accountNumber = $(e.currentTarget).data('account-number');
        const url = $(e.currentTarget).data('url');
        app.cw.common.PopupModal.show('Retirement Data for ' + accountNumber, url,
            {
                AccountId: accountId,
                AccountNumber: accountNumber,
                ...app.cw.common.Kendo.forgeryToken()
            });
    });

    $(document.body).on('click', '.cw_ajax_account_gain_loss_btn', function (e) {
        e.preventDefault();
        const accountId = $(e.currentTarget).data('account-id');
        const accountNumber = $(e.currentTarget).data('account-number');
        const url = $(e.currentTarget).data('url');
        app.cw.common.PopupModal.show('Gain/Loss for ' + accountNumber, url,
            {
                AccountId: accountId,
                AccountNumber: accountNumber,
                ...app.cw.common.Kendo.forgeryToken()
            });
    });

    // Logging form loading indicator
    var $loginForm = $('#cw_ajax_login_form');
    var $loginBtn = $('#cw_ajax_login_btn');
    var loadingText = '<i class="fa fa-refresh fa-spin"></i> Logging In...';

    $loginForm.on('submit', function (e) {
        // show loading indicator
        if ($loginBtn.html() !== loadingText) {
            $loginBtn.html(loadingText);
        }
    });

    if (window.location.pathname.includes('/Account/') || window.location.pathname.includes('/Manage/'))
        return;

    // Draggable Modal
    // https://stackoverflow.com/questions/12571922/make-bootstrap-twitter-dialog-modal-draggable
    $(document.body).on('mousedown', '.cw_ajax_modal_header', function (mousedownEvt) {
        const $draggable = $(this);
        const x = mousedownEvt.pageX - $draggable.offset().left,
            y = mousedownEvt.pageY - $draggable.offset().top;

        $(document.body).on('mousemove.draggable', function (mousemoveEvt) {
            $draggable.closest('.cw_ajax_modal_content').offset({
                'left': mousemoveEvt.pageX - x,
                'top': mousemoveEvt.pageY - y
            });
        });

        $(document.body).one('mouseup', function () {
            $(document.body).off('mousemove.draggable');
        });

        $draggable.closest('.modal').one('bs.modal.hide', function () {
            $(document.body).off('mousemove.draggable');
        });
    });


    // NOTIFICATION DISMISSED WRITE TO DB.
    $('[data-user-hide]').on('click', function (e) {
        var notificationBanner = $(this).closest("." + $(this).attr("data-user-hide"));
        var notificationId = $(this).closest("." + $(this).attr("data-user-hide")).attr("data-sys-notification-id");
        const $dataDiv = $('#ix_ajax_json_data_div');

        $.ajax({
            url: $dataDiv.data('dismiss-system-notification-url'),
            type: 'POST',
            data: { notificationId: notificationId }
        }).done(function (data) {
            // Hides alert
            notificationBanner.addClass('d-none');
        }).fail(function () {
            //Display Error
            notificationBanner.addClass('d-none');
        });
    });

    // NOTIFICATION POPUP
    // Only show modal once per session.
    if (!sessionStorage.getItem('shown-modal')) {
        $("#PopupModal").modal('show');
        var isVisiable = $('#PopupModal').is(':visible');
        // Make sure modal is shown before tagging it as shown for the session.
        if (isVisiable == true) {
            sessionStorage.setItem('shown-modal', 'true');
        }
    }
    $('#ix_db_modal_close_btn').click(function (e) {
        $('#PopupModal').modal('hide');
    });
});

app.cw.common.Kendo = {
    forgeryToken: function forgeryToken() {
        return kendo.antiForgeryTokens();
    }
};

//Tabs functionality
app.cw.common.Tabs = {
    tabLoadingOn: function () {
        app.cw.common.LoadingSpinner.show("Retrieving data...");
    },
    tabLoadingOff: function () {
        app.cw.common.LoadingSpinner.hide();
    }
};
//End Tabs functionality

// Grid Helpers
app.cw.common.Grids = {
    onErrorHandler: function onErrorHandler(args, gridId) {
        // Reference to grid
        var grid = $('#' + gridId).data('kendoGrid');

        // Assign dummy error for undefined errors
        // For example if the server times out "errors" is empty
        if (args.errors) {
            myErrors = args.errors;
        }
        else {
            if (args.xhr.responseJSON && args.xhr.responseJSON.message)
                myErrors = { 'Unknown': { 'errors': [args.xhr.responseJSON.message] } };
            else
                myErrors = { 'Unknown': { 'errors': ['Server Error'] } };
        }

        // separate warnings and errors into two arrays
        var allMyErrors = [];
        var allMyWarnings = [];
        var allMyInfo = [];
        $.each(myErrors, function (propertyName) {
            $.each(this, function (name, value) {
                if (propertyName === 'warning') {
                    allMyWarnings = $.merge(allMyWarnings, value);
                }
                else if (propertyName === 'info') {
                    allMyInfo = $.merge(allMyInfo, value);
                }
                else {
                    allMyErrors = $.merge(allMyErrors, value);
                }
            });
        });

        if (allMyInfo.length > 0) {
            app.cw.common.Notification.show('Information', allMyInfo, 'infoList'); // title, message, type
        }

        if (allMyWarnings.length > 0) {
            app.cw.common.Notification.show('Warning', allMyWarnings, 'warningList'); // title, message, type
        }

        if (allMyErrors.length > 0) {
            app.cw.common.Notification.show('Errors', allMyErrors, 'errorList'); // title, message, type
        }

        // cancel grid rebind so that popup stays in place
        grid.one('dataBinding', function (e) {
            e.preventDefault();
        });
    }
}

//*********************************************************************Home****************************************************************
app.cw.common.Home = {
    //Password validation
    validatePasswords: function () {
        var errorText = '';
        var regDigits = new RegExp('[0-9]');
        var regLowercase = new RegExp('[a-z]');
        var regUppercase = new RegExp('[A-Z]');

        var tOldPwrd = document.getElementById('tOldPwrd');
        var tNewPwrd = document.getElementById('tNewPwrd');
        var tRePwrd = document.getElementById('tRePwrd');
        var lErr = document.getElementById('lErr');
        var lErrDet = document.getElementById('lErrDet');

        if (tOldPwrd.value != '' && tNewPwrd.value == '' && tRePwrd.value == '')
            return;

        if (tOldPwrd.value == '')
            errorText += "Please enter Current Passphrase <br>";
        if (tNewPwrd.value == '')
            errorText += "Please enter New Passphrase <br>";
        if (tRePwrd.value == '')
            errorText += "Please enter RE-New Passphrase <br>";
        if (tNewPwrd.value == tOldPwrd.value)
            errorText += "Please enter New Passphrase different from Old Passphrase<br>";
        if (tNewPwrd.value.length < 8 || !tNewPwrd.value.match(regDigits)
            || !tNewPwrd.value.match(regLowercase) || !tNewPwrd.value.match(regUppercase)) {
            errorText += "Your passphrase must <br>";
        }

        if (tNewPwrd.value.length < 8)
            errorText += "   - have at least 8 characters <br>";
        if (!tNewPwrd.value.match(regDigits))
            errorText += "   - have at least one number <br>";
        if (!tNewPwrd.value.match(regLowercase))
            errorText += "   - have at least one lowercase letter <br>";
        if (!tNewPwrd.value.match(regUppercase))
            errorText += "   - have at least one capital letter <br>";

        if (errorText != '') {
            lErr.innerHTML = "";
            lErrDet.innerHTML = errorText;
        }
        else {
            lErr.innerHTML = "";
            lErrDet.innerHTML = "";
        }
    },
    checkPass: function () {
        var info = document.getElementById('img');
        var newpwd = document.getElementById('tNewPwrd');
        var renewpwd = document.getElementById('tRePwrd');
        var s = (newpwd.value != renewpwd.value) ? '0' : '1';

        if (s == '1')
            info.src = '/Images/ok.png';
        else
            info.src = '/Images/wrong.png';

        var lErrDet = document.getElementById('lErrDet');

        if (newpwd.value == '' || renewpwd.value == '')
            info.src = '/Images/empty.png';
        else if (lErrDet.innerHTML != '')
            info.src = '/Images/wrong.png';

    },

    checkPassSave: function () {

        var oldpwd = document.getElementById('tOldPwrd');
        var newpwd = document.getElementById('tNewPwrd');
        var renewpwd = document.getElementById('tRePwrd');
        var lErrDet = document.getElementById('lErrDet');

        if (newpwd.value != renewpwd.value)
            return false;
        else if (newpwd.value == '' || renewpwd.value == '' || oldpwd.value == '')
            return false;
        else if (newpwd.value == oldpwd.value)
            return false;
        else if (lErrDet.innerHTML != '')
            return false;
        else {
            $.post("/Home/ChangePassword", { tOldPwrd: oldpwd.value, tNewPwrd: newpwd.value, tRePwrd: renewpwd.value })
                .done(function (data) {
                    //console.log(data);
                    $('#main-menu-4').html(data);
                });
        }
    }
    //End Password validation
};

app.cw.Dashboard = {
    accountDateFilter_onChange: function accountDateFilter_onChange(e) {
        const $accountTile = $(e.sender.wrapper).closest('.cw_ajax_account_tile');
        const accountId = $accountTile.data('account-id');
        const $totalAccountVal = $accountTile.find('.cc_ajax_account_total_account_value');
        const $asOfDate = $accountTile.find('.cc_ajax_account_as_of_date');

        const $dataDiv = $('#cw_ajax_json_data_div');

        $.ajax({
            url: $dataDiv.data('get-account-balance-url'),
            type: 'POST',
            data: { AccountId: accountId, IsRealTime: this.value() },
            beforeSend: function () {
                // Show loading indicator
                $totalAccountVal.addClass('placeholder');
                $asOfDate.addClass('placeholder');
            }
        }).done(function (data) {
            $totalAccountVal.text(kendo.toString(data.TotalAccountValue, 'C2'));
            $asOfDate.text(kendo.toString(new Date(data.AsOfDate), 'd'));

            // Hide loading indicator
            $totalAccountVal.removeClass('placeholder');
            $asOfDate.removeClass('placeholder');
        }).fail(function (err) {
            console.log(err);
        });
    }
};

app.cw.Holding = {
    grid_getData: function grid_getData() {
        const isRealTimeId = $('.cw_ajax_holding_is_real_time_switch').find('[data-role="switch"]').prop('id');
        const $isRealTime = $('#' + isRealTimeId).data('kendoSwitch');
        return {
            IsRealTime: $isRealTime?.value(),
            ...app.cw.common.Kendo.forgeryToken()
        };
    },
    isRealTime_onChange: function isRealTime_onChange(e) {
        const $holdingGrid = $('#Holdings').data('kendoGrid');
        if ($holdingGrid)
            $holdingGrid.dataSource.read();
    },
    // SelectedAccountId
    selectedAccountId_widgetId: 'SelectedAccountId',
    selectedAccountId_getValue: function selectedAccountId_getValue() {
        const $widget = $('#' + app.cw.Holding.selectedAccountId_widgetId).data('kendoDropDownList');
        return $widget.value();
    },
    selectedAccountId_onChange: function selectedAccountId_onChange() {
        const $dataDiv = $('#cw_ajax_json_data_div');
        const accountId = this.value();

        app.cw.Holding.updateSelectedAccountDetail();

        $.ajax({
            url: $dataDiv.data('load-holding-partial-by-account-url'),
            type: 'POST',
            data: { AccountId: accountId },
            beforeSend: function () {
                
            }
        }).done(function (data) {
            $('#cw_ajax_holding_grid_wrapper').html(data);
        }).fail(function (err) {
            console.log(err);
        });
    },
    selectedAccountId_onDataBound: function selectedAccountId_onDataBound() {
        if (this.value() === '') {
            this.select(0);
        }
        app.cw.Holding.updateSelectedAccountDetail();
    },
    updateSelectedAccountDetail: function updateSelectedAccountDetail() {
        const accountId = app.cw.Holding.selectedAccountId_getValue();
        const $dataDiv = $('#cw_ajax_json_data_div');

        $.ajax({
            url: $dataDiv.data('update-selected-account-detail-url'),
            type: 'POST',
            data: {
                AccountId: accountId,
                IsRealTime: $('#Holding_IsRealTime_' + accountId).val()
            },
            beforeSend: function () {
                $('.cc_ajax_account_summary').addClass('placeholder');
            }
        }).done(function (data) {
            $('.cc_ajax_account_summary').removeClass('placeholder');

            $('.cw_ajax_selected_account_detail_type').text(data.RegistrationType);
            $('.cw_ajax_selected_account_detail_value').text(data.TotalValue);
            $('.cw_ajax_selected_account_detail_total_holding').text(data.TotalHolding);
        }).fail(function (err) {
            console.log(err);
        });
    },
};

//*****************************************************************History***********************************************************
app.cw.History = {
    // SelectedAccountId
    selectedAccountId_widgetId: 'SelectedAccountId',
    selectedAccountId_getValue: function selectedAccountId_getValue() {
        const $widget = $('#' + app.cw.History.selectedAccountId_widgetId).data('kendoDropDownList');
        return $widget.value();
    },
    selectedAccountId_onChange: function selectedAccountId_onChange() {
        $('#' + app.cw.History.selectedHoldingId_widgetId).data('kendoDropDownList')?.dataSource.read();
        $('#' + app.cw.History.transactionDateFilter_widgetId).data('kendoDropDownList')?.dataSource.read();

        app.cw.History.updateSelectedAccountDetail();
    },
    selectedAccountId_onDataBound: function selectedAccountId_onDataBound() {
        if (this.value() === '') {
            this.select(0);
        }
        app.cw.History.updateSelectedAccountDetail();
    },
    // SelectedHoldingId
    selectedHoldingId_widgetId: 'SelectedHoldingId',
    selectedHoldingId_getValue: function selectedHoldingId_getValue() {
        const $widget = $('#' + app.cw.History.selectedHoldingId_widgetId).data('kendoDropDownList');
        return $widget.value();
    },
    selectedHoldingId_getData: function selectedHoldingId_getData() {
        return {
            AccountId: app.cw.History.selectedAccountId_getValue()
        };
    },
    selectedHoldingId_onChange: function selectedHoldingId_onChange() {
        app.cw.History.historyGrid_read();
    },
    selectedHoldingId_onDataBound: function selectedHoldingId_onDataBound() {
        if (this.value() === '') {
            this.select(0);
        }
    },
    // Transaction Date Filter
    transactionDateFilter_widgetId: 'TransactionDateFilterValue',
    transactionDateFilter_getValue: function transactionDateFilter_getValue() {
        const $widget = $('#' + app.cw.History.transactionDateFilter_widgetId).data('kendoDropDownList');
        return $widget.value();
    },
    transactionDateFilter_getData: function transactionDateFilter_getData() {
        return {
            AccountId: app.cw.History.selectedAccountId_getValue()
        };
    },
    transactionDateFilter_onChange: function transactionDateFilter_onChange() {
        const $customDateField = $('.cc_ajax_history_custom_date_field');
        if (this.value() == 'Custom') {
            $customDateField.removeClass('d-none');
        }
        else {
            $customDateField.addClass('d-none');
            app.cw.History.historyGrid_read();
        }
    },
    transactionDateFilter_onDataBound: function transactionDateFilter_onDataBound() {
        this.select(0);
        app.cw.History.historyGrid_read();
    },
    updateSelectedAccountDetail: function updateSelectedAccountDetail() {
        const accountId = app.cw.History.selectedAccountId_getValue();
        const $dataDiv = $('#cw_ajax_json_data_div');
        
        $.ajax({
            url: $dataDiv.data('update-selected-account-detail-url'),
            type: 'POST',
            data: { AccountId: accountId },
            beforeSend: function () {
                $('.cc_ajax_account_summary').addClass('placeholder');
            }
        }).done(function (data) {
            $('.cc_ajax_account_summary').removeClass('placeholder');

            $('.cw_ajax_selected_account_detail_type').text(data.RegistrationType);
            $('.cw_ajax_selected_account_detail_value').text(data.TotalValue);
            $('.cw_ajax_selected_account_detail_open').text(data.OpenDate);
        }).fail(function (err) {
            console.log(err);
        });
    },
    // AccountHistoryGrid
    historyGrid_widgetId: 'AccountHistoryGrid',
    historyGrid_getData: function historyGrid_getData() {
        const dateFrom = $('#HistoryDateFrom').data('kendoDatePicker').value();
        const dateTo = $('#HistoryDateTo').data('kendoDatePicker').value();

        var data = {
            SelectedAccountId: app.cw.History.selectedAccountId_getValue(),
            SelectedHoldingId: app.cw.History.selectedHoldingId_getValue(),
            TransactionDateFilterValue: app.cw.History.transactionDateFilter_getValue(),
            HistoryDateFrom: dateFrom,
            HistoryDateTo: dateTo,
            ...app.cw.common.Kendo.forgeryToken()
        };

        return data;
    },
    historyGrid_read: function historyGrid_read() {
        const $widget = $('#' + app.cw.History.historyGrid_widgetId).data('kendoGrid');
        if ($widget)
            $widget.dataSource.read();
    },
    getHistoryBtn_onClick: function getHistoryBtn_onClick() {
        app.cw.History.historyGrid_read();
    },
    resetBtn_onClick: function resetBtn_onClick() {
        var lastMonth = new Date();
        lastMonth.setMonth(lastMonth.getMonth() - 1);

        $('#HistoryDateFrom').data('kendoDatePicker').value(lastMonth);
        $('#HistoryDateTo').data('kendoDatePicker').value(new Date());

        app.cw.History.historyGrid_read();
    }
}

app.common = {
    AnyGrid_DataBound: function AnyGrid_DataBound(e) {
        // replace top left corner th with td per ADA compliance
        e.sender.element.find('.k-hierarchy-cell.k-header').contents().unwrap().wrap('<td class="k-hierarchy-cell k-header" />');
    }
};
//****************************************************************************************************************